import { useEffect, useState } from "react";

// #645 — a plain wall clock, always ticking (unlike useEntityTick, which
// pauses offline — staleness must be detectable EXACTLY when we're offline).
// Purely a re-render trigger for the freshness banner's math; fetches nothing.
export function useNow(intervalMs) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
